import ApiService from '../../utils/fetch';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchInboundShipments = async ({
  page = 0,
  size = 10,
  sort = [],
  filters = {},
}) => {


  const params = new URLSearchParams();
  params.append('page', page);
  params.append('size', size);
  if (sort && Array.isArray(sort)) {
    sort.forEach(s => params.append('sort', s)); // multiple sort params
  }
  
 

 

  const response = await ApiService.post(
    `${BASE_URL}supply/shipments?${params}`,
    {
      ...filters, 
    }
  );

  const res = response.data;

  return {
    rows: res.content,
    totalPages: res.totalPages,
    totalElements: res.totalElements,
  };
};

/**
 * Fetch distinct filter options for a specific column
 * @param {string} column - Column name (supplier, customer, carrier, shipmentNo, state, exceptionType, fromSite)
 * @param {object} appliedFilters - Currently applied filters for cascading behavior (can include searchText for shipmentNo)
 * @returns {Promise<string[]>} Array of distinct values for the column
 */
export const fetchFilterOptions = async (column, appliedFilters = {}) => {
  try {
    const params = new URLSearchParams();
    params.append('column', column);

    // Prepare request body per new API contract
    const requestBody = {
      appliedFilters: appliedFilters?.appliedFilters || appliedFilters || {},
    };
    if (appliedFilters?.selectedStates) {
      requestBody.selectedStates = appliedFilters.selectedStates;
    }
    if (appliedFilters?.selectedExceptions) {
      requestBody.selectedExceptions = appliedFilters.selectedExceptions;
    }

    const response = await ApiService.post(
      `${BASE_URL}supply/shipments/filter-options?${params}`,
      requestBody
    );
    return response.data.values || [];
  } catch (error) {
    console.error(`Error fetching filter options for ${column}:`, error);
    return [];
  }
};



